import { render } from "./button.vue?vue&type=template&id=3f182b9c&lang=pug"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"
script.render = render

export default script